
<div class="title_bg">
  <div class="title_text">
    <h1 class="title">
      Тренировочный экзамен ПДД — билет {{(this.bilet_index+1)}}, вопрос {{this.question_index+1}}

    </h1>
    <div class="title_mobile">
      Тренировочный экзамен ПДД — билет {{(this.bilet_index+1)}}, вопрос {{this.question_index+1}}
    </div>
  </div>

</div>

<ng-container *ngIf="this.BilletsService.billets_list[this.bilet_index].length == my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length">
  <div style="padding-top: 20px;">
    <div style="
  padding: 10px;
  display: grid;
  gap: 10px;
  background: #f5f5f7;
  border-radius: 6px;
  border: solid 1px #f5f5f7;
  color: #1d1d1f;">
      <div>
        <b>Результаты</b>
      </div>
      <div>
        <div>
          Правильных ответов: <span style="color: #00cc66;">{{count_success()}}</span>
        </div>
        <div>
          Допущено ошибок: <span style="color: #ff4e43;">{{count_error()}}</span>
        </div>
      </div>

    </div>
  </div>
</ng-container>


<div style="display: grid; gap: 20px;  padding-top: 20px;">
  <div  [class]="{'billets_list_control':this.scroll_billets.all_billets == false, 'billets_list_control_none_scroll':this.scroll_billets.all_billets == true,}">
    <div style="position: relative; width: 100%; overflow: hidden;">
      <div *ngIf=" this.scroll_billets.scrollLeft > 0 && this.scroll_billets.all_billets == false"
           style="position: absolute; left: 0px; top: 0px; bottom: 0px; display: flex; align-items: center; gap: 10px; background: #fff; background: linear-gradient(90deg,rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%);">
        <div (click)="scrollLeft(scrollContainerBillets)"
             style="padding: 5px; background: #1a1a1a; border-radius: 6px; cursor: pointer;">
          <i class="icon_scroll_left"></i>
        </div>
        <div style="width: 10px;"></div>
      </div>

      <div *ngIf="!this.scroll_billets.isEnd  && this.scroll_billets.all_billets == false"
           style="position: absolute; right: 0px; top: 0px; bottom: 0px; display: flex; align-items: center; gap: 10px; background: #fff; background: linear-gradient(90deg,rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%);">
        <div style="width: 10px;"></div>
        <div (click)="scrollRight(scrollContainerBillets)"
             style="padding: 5px; background: #1a1a1a; border-radius: 6px;  cursor: pointer;">
          <i class="icon_scroll_right"></i>
        </div>
      </div>
      <div
        [class]="{'list_billets': this.scroll_billets.all_billets == false,  'none_vue_scroill': this.scroll_billets.all_billets == false, 'list_billets_none_scroll': this.scroll_billets.all_billets == true}"
        #scrollContainerBillets (scroll)="onScroll($event)" (mousedown)="onMouseDown($event, scrollContainerBillets)">

        <ng-container *ngFor="let billet of  this.BilletsService.billets_list[this.bilet_index]; let  i = index">
          <ng-container *ngIf="questionsMap.get(billet) as billet_question">
              <div #billet (click)="openBillet((i))"
                   [class]="{
                 'billet':!billet_question.bilet_trenerovachnyy_ekzamen?.select,
                 'billet_checked': (billet_question.bilet_trenerovachnyy_ekzamen?.select  && ( my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length < BilletsService.billets_list[bilet_index].length && this.totalSeconds > 0)) ,
                 'billet_success': (billet_question.bilet_trenerovachnyy_ekzamen?.select && billet_question.bilet_trenerovachnyy_ekzamen?.status && ((my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length == BilletsService.billets_list[bilet_index].length || this.totalSeconds == 0))),
                 'billet_error': (billet_question.bilet_trenerovachnyy_ekzamen?.select && !billet_question.bilet_trenerovachnyy_ekzamen?.status && ((my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length == BilletsService.billets_list[bilet_index].length || this.totalSeconds == 0))),
                 'active': i==this.question_index}">
                {{ i + 1 }}
              </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div
      style="padding: 5px; background: #1a1a1a; border-radius: 6px; display: flex; justify-content: center; align-items: center;"
      (click)="vueAllBillets()">
      <div
        style="cursor: pointer; display: flex; color: #fff; justify-content: center; align-items: center; gap: 10px;">
        <div *ngIf=" this.scroll_billets.all_billets == true">
          Свернуть спиоско билетов
        </div>
        <div>
          <i
            [class]="{'icon_dispaly_all': this.scroll_billets.all_billets == false, 'icon_dispaly_none_all': this.scroll_billets.all_billets == true}"></i>
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex;">
    <div #timerHTML class="timer" style="padding: 0px 6px;  min-height: 25px;border-radius: 6px; background: #1a1a1a; color: #fff; cursor: pointer;  display: flex;   justify-content: center;  align-items: center; ">
      20:00
    </div>
  </div>
  <div>
    <ng-container *ngFor="let billet of this.BilletsService.billets_question; let  i = index">
      <ng-container *ngIf="billet.id==this.id_question">
        <div style="display: grid; gap: 10px;">
          <ng-container *ngIf="billet.question.img">
            <div>
              <img src="{{billet.question.img}}" alt="{{billet.question.text}}" fetchpriority="high">
            </div>
          </ng-container>
          <ng-container *ngIf="!billet.question.img">
            <div>
              <img src="/assets/billets/none_img.png" alt="{{billet.question.text}}" fetchpriority="high">
            </div>
          </ng-container>
          <div class="question">
            <h2>{{ billet.question.text }}</h2>
          </div>
          <div>
            <ul class="answers">
              <ng-container *ngFor="let answer of billet.answers;  let  answer_index = index">
                <li (click)="chekAnswer(i, answer_index)" [class]="{
                'none_select': billet.bilet_trenerovachnyy_ekzamen?.select == true || this.totalSeconds == 0 ,
                'success':( (answer.bilett_trenerovachnyy_ekzamen_select && answer.correct) || (answer.correct == true && billet.bilet_trenerovachnyy_ekzamen?.select == true)) && ((  my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length ==  BilletsService.billets_list[bilet_index].length  || this.totalSeconds == 0)),
                'error': answer.bilett_trenerovachnyy_ekzamen_select && !answer.correct && ( (  my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length ==  BilletsService.billets_list[bilet_index].length  || this.totalSeconds == 0)),
                'anonymous': answer.bilett_trenerovachnyy_ekzamen_select  &&  ( my_answer_bilet_trenerovachnyy_ekzamen?.list_question?.length <  BilletsService.billets_list[bilet_index].length  && this.totalSeconds > 0)
                }">
                  <div class="number">
                    <div>
                      {{ answer_index + 1 }}
                    </div>
                  </div>
                  <div>
                    {{ answer.text }}
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
          <div style="display: grid; gap: 10px;  gap: 10px;">
            <div
              [class]="{'open_explanation':open_explanation == true, 'close_explanation':open_explanation == false}">
              <ng-container *ngFor="let answer of billet.answers;">
                <ng-container *ngIf="answer.correct  == true">
                  <div
                    style="padding: 10px; background: #fff6e9; border-radius: 6px; border: solid 1px #ffaa33; color: #000;">
                    <div>
                      <h2 style="color: #ffaa33; font-size: 16px;">Объяснение</h2>
                    </div>
                    <div>
                      {{ answer.description }}
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div style="display: flex; gap: 10px;">
              <div style="width: 100%;">
                <button class="explanation" (click)="open_explanation = !open_explanation">
                  <div>
                    <ng-container *ngIf="open_explanation == false">
                      Показать подсказу
                    </ng-container>
                    <ng-container *ngIf="open_explanation == true">
                      Скрыть подсказу
                    </ng-container>
                  </div>
                  <div>
                    <i class="icon_element"></i>
                  </div>
                </button>
              </div>
              <div *ngIf="question_index < this.BilletsService.billets_list[this.bilet_index].length-1">

                <button class="next_question" (click)="nextQuiz()">
                  <div>
                    Следущий вопрос
                  </div>
                  <div>
                    <i class="icon_next"></i>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<settings-component></settings-component>
